import gql from 'graphql-tag';
import produce from 'immer';
import { updateListFilterQueryString } from './updateQueryString';
export const listFilterHasActiveItems = function listFilterHasActiveItems(parent) {
    return (searchParams) => {
        // During SSR, search params are passed in when instantiating Apollo Client.
        // Otherwise, get them from the document location
        const query = __IN_SERVER__ ? searchParams : document.location.search;
        // If the search params include the parent id, this filter is applied
        return query === null || query === void 0 ? void 0 : query.includes(parent.id);
    };
};
////////////////////////////////////////////////////////////////////////////////
/**
 * Mutation to clear a list filter's hasActiveItems state, and all child
 * listFilterItem isActive state
 */
export const clearListFilter = (_, { id }, { cache, getCacheKey }) => {
    const fragmentId = getCacheKey({ id, __typename: 'ListFilter' });
    const filter = cache.readFragment({
        id: fragmentId,
        fragment: gql `
      fragment listFilterItems on ListFilter {
        hasActiveItems @client
        id
        items {
          id
          isActive @client
        }
      }
    `
    });
    const data = produce(filter, draft => {
        draft.hasActiveItems = false;
        draft.items.forEach(item => (item.isActive = false));
    });
    cache.writeData({
        id: fragmentId,
        data
    });
    const activeFilters = updateActiveFilters(cache, id);
    window.location.search && updateListFilterQueryString(activeFilters);
    return data;
};
////////////////////////////////////////////////////////////////////////////////
/**
 * Update the active filters in the cache root.
 * @param cache Apollo Client cache
 * @param id The ListFilter ID
 * @returns All active filters
 */
function updateActiveFilters(cache, id) {
    const activeListFilterQuery = gql `
    query GetActiveListFilters {
      activeFilters @client {
        listFilters {
          id
          values
        }
      }
    }
  `;
    const { activeFilters } = cache.readQuery({
        query: activeListFilterQuery
    });
    const data = produce(activeFilters, draft => {
        draft.listFilters = draft.listFilters.filter(listFilter => listFilter.id !== id);
    });
    cache.writeData({
        data: { activeFilters: data }
    });
    return data;
}
//# sourceMappingURL=listFilter.js.map